import { Link } from "react-router-dom";
import { MailCheck } from "lucide-react";
import { useLang } from "../context/LangContext";

export default function Register() {
  const { t, lang, setLang } = useLang();

  return (
    <div className="min-h-screen grain relative flex items-center justify-center px-4 py-10">
      <button
        onClick={() => setLang(lang === "fr" ? "en" : "fr")}
        className="absolute top-6 right-6 text-xs uppercase tracking-widest text-slate-300 px-3 py-1.5 rounded-lg hover:bg-white/5 z-10"
      >
        {lang}
      </button>
      <div className="w-full max-w-md relative z-[2]">
        <div className="flex items-center gap-4 mb-8">
          <div className="w-16 h-16 rounded-2xl overflow-hidden flex items-center justify-center flex-shrink-0" style={{ background: "#0A3F4A" }}>
            <img src="/cen21-logo.webp" alt="Cen21" className="w-full h-full object-contain" style={{ transform: "scale(2.4)" }} />
          </div>
          <div>
            <div className="text-2xl font-bold tracking-tight" style={{ fontFamily: "Outfit" }}>{t("app_name")}</div>
            <div className="text-xs text-slate-400">{t("tagline")}</div>
          </div>
        </div>
        <div className="glass rounded-3xl p-8" data-testid="register-invite-only">
          <div className="w-12 h-12 rounded-xl bg-indigo-500/15 border border-indigo-400/30 flex items-center justify-center mb-4">
            <MailCheck className="w-6 h-6 text-indigo-300" />
          </div>
          <h1 className="text-2xl font-bold mb-2" style={{ fontFamily: "Outfit" }}>{t("invite_only_title")}</h1>
          <p className="text-sm text-slate-400">{t("invite_only_hint")}</p>
          <div className="mt-8 text-sm text-slate-400 text-center">
            {t("has_account")}{" "}
            <Link data-testid="register-login-link" to="/login" className="text-indigo-400 hover:text-indigo-300">{t("login")}</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
